import {Component, Input} from '@angular/core';
import {StatusesViewModel} from './statuses-view.model';

@Component({
  selector: 'app-statuses-view',
  templateUrl: './statuses-view.component.html',
  styleUrls: ['./statuses-view.component.scss']
})
export class StatusesViewComponent {
  @Input() statuses: Array<StatusesViewModel>;

  constructor() {
  }
}
